function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5926 41.8245C31.9656 41.8245 41.1852 32.6049 41.1852 21.2319C41.1852 9.85892 31.9656 0.6393 20.5926 0.6393C9.21962 0.6393 0 9.85892 0 21.2319C0 32.6049 9.21962 41.8245 20.5926 41.8245Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4801 32.2985H20.48C20.4106 32.2431 18.4625 30.6809 16.4898 28.2773C14.3469 25.6658 12.4814 22.4259 12.4814 19.1492C12.4814 14.5778 16.1295 10.874 20.5929 10.874C25.0563 10.874 28.7043 14.5778 28.7043 19.1492C28.7043 22.4263 26.8385 25.6667 24.696 28.2773L25.0825 28.5945L24.696 28.2773C22.7233 30.6809 20.7752 32.2431 20.7057 32.2985L20.7054 32.2988C20.6387 32.352 20.5472 32.352 20.4801 32.2985ZM16.1234 18.4893C16.1234 20.9872 18.1189 23.0343 20.5929 23.0343C23.0669 23.0343 25.0623 20.9872 25.0623 18.4893C25.0623 15.9914 23.0669 13.9444 20.5929 13.9444C18.1189 13.9444 16.1234 15.9914 16.1234 18.4893Z",
  stroke: "#4D5056"
});

function SvgIconPinInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinInactive);
export default __webpack_public_path__ + "static/media/icon_pin_inactive.18d42a68.svg";
export { ForwardRef as ReactComponent };